import {
  getPendingChanges,
  type ContractorGetCampaignModel,
  type ManagerGetCampaignModel,
  type CampaignTypes,
} from 'entities/campaign';

import { campaignTypeToTextMapper } from './campaign-type-text-mapper';

const getText = (isPaused: boolean, type: keyof typeof CampaignTypes) => {
  return isPaused
    ? `This campaign will stop receiving ${campaignTypeToTextMapper[type]} on`
    : `This campaign will start receiving ${campaignTypeToTextMapper[type]} on`;
};

export const usePendingRunStatus = (campaign: ManagerGetCampaignModel | ContractorGetCampaignModel) => {
  const pendingChanges = getPendingChanges(campaign, {
    running: false,
    pause: false,
  });

  const isPaused = pendingChanges.pause;
  const isRunning = pendingChanges.running;

  return {
    tooltipText: getText(isPaused, campaign.type),
    isPendingIcon: isPaused || isRunning,
  };
};
